import { LumpsumPlanStatus } from '../../../api/common.types'

/** Plan list / header / filters only when status is rolled out. */
export function isPlanRolledOut(planStatus?: LumpsumPlanStatus | null): boolean {
  return planStatus === LumpsumPlanStatus.PLAN_ROLLED_OUT
}

/** Rebalance has no planStatus — BE gates list vs timer with isPlanAvailable. */
export function isRebalancePlanAvailable(isPlanAvailable?: boolean | null): boolean {
  return isPlanAvailable === true
}

/** Find-your-strategy shell (questionnaire not started). */
export function isStrategyNotStarted(planStatus?: LumpsumPlanStatus | null): boolean {
  return (
    planStatus == null || planStatus === LumpsumPlanStatus.QUESTIONNAIRE_NOT_INITIATED
  )
}

/** Complete-your-strategy shell (questionnaire started, not submitted). */
export function isStrategyInProgress(planStatus?: LumpsumPlanStatus | null): boolean {
  return planStatus === LumpsumPlanStatus.QUESTIONNAIRE_IN_PROGRESS
}

/** Strategy CTA shell — not yet on timer (submitted / re-submitted). */
export function shouldShowStrategyShell(planStatus?: LumpsumPlanStatus | null): boolean {
  return isStrategyNotStarted(planStatus) || isStrategyInProgress(planStatus)
}
